/* eslint-disable react/display-name */
import { lazy } from "react";
const TempSensorManagePage = lazy(() => import("./pages/manage"));
const FirmwareManagePage = lazy(() => import("./pages/firmware"));

const TempSensorRoutes = [
  { path: "manage", element: <TempSensorManagePage /> },
  { path: "firmware", element: <FirmwareManagePage /> }
];

export default TempSensorRoutes;
